import * as React from 'react'
import { Link } from 'react-router-dom'
import {Button, TYPES} from './../shared/button'

import './../../styles/review/reviewSelect.css'
import car from './../../images/car.png'

class ReviewSelect extends React.Component {

  outputRecordingLink = (num) => {
    const visit = this.props.visit
    if(typeof(visit.recordings[num].angle) === 'number' && visit.recordings[num].id !== null) {
      return (
        <Link to={`/recordings/${this.props.visit.recordings[num].id}`}>
          <Button
            text={this.props.visit.recordings[num].angle_name}
            type='reviewOne'
            buttonType={TYPES.DEFAULT}
          />
        </Link>
      )
    } else if(typeof(visit.recordings[num].angle) === 'number' && visit.recordings[num].id === null) {
      return (
        <div>
          <div className='uploading-angle'>
            <p>{this.props.visit.recordings[num].angle_name}</p>
            <p>Awaiting Upload</p>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div className='review-select'>
        <div className='review-side-buttons'>
          <div>
            <div className='side-button-container'>
              {this.outputRecordingLink(5)}
            </div>
            <div className='side-button-container'>
              {this.outputRecordingLink(6)}
            </div>
            <div className='side-button-container'>
              {this.outputRecordingLink(7)}
            </div>
          </div>
        </div>
        <div className='center-column'>
          <div className='review-top-buttons'>
            <div className='top-button-container'>
              <div className='top-button'>
                {this.outputRecordingLink(4)}
              </div>
              <div className='top-button'>
                {this.outputRecordingLink(3)}
              </div>
            </div>
          </div>
          <div className='review-select-border'>
            <img src={car} alt='Car' />
          </div>
        </div>
        <div className='review-side-buttons'>
          <div>
            <div className='side-button-container'>
              {this.outputRecordingLink(0)}
            </div>
            <div className='side-button-container'>
              {this.outputRecordingLink(1)}
            </div>
            <div className='side-button-container'>
              {this.outputRecordingLink(2)}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ReviewSelect



// WEBPACK FOOTER //
// ./src/components/review/reviewSelect.js